import type {
  ActivityToBook,
  SelectedTicketInfo,
  GraphQL,
  BusinessCriteria,
} from '@libs/trip-planner-interfaces';
import { normalizeDateOnlyString } from '@libs/utils';

import { getMarketOrigin } from '../../utils';

export function getBookingTokenRequestQL(
  activitiesToBook: ActivityToBook[],
  businessCriteria: BusinessCriteria
): GraphQL.BookingTokenRequestQL {
  return {
    market: getMarketOrigin(),
    activities: activitiesToBook.map(getActivityQL),
    affiliateId: businessCriteria.affiliateId ?? null,
  };
}

function getActivityQL(activityToBook: ActivityToBook): GraphQL.ActivityQL {
  const { code, date, tickets } = activityToBook;

  return {
    code,
    dateOnly: normalizeDateOnlyString(date),
    tickets: tickets.map(getSelectedTicketQL),
  };
}

export function getSelectedTicketQL(
  ticketInfo: SelectedTicketInfo
): GraphQL.SelectedTicketQL {
  return {
    ageRangeId: ticketInfo.ageRangeId,
    quantity: ticketInfo.quantity,
    rateId: ticketInfo.rateId,
    timeSlotId: ticketInfo.timeSlotId,
    supplierToken: ticketInfo.supplierToken,
    getQuantityFromPax: ticketInfo.getQuantityFromPax,
  };
}
